<template>
  <div class="kpt-remote-detail-map" v-if="primaryStatus && (primaryStatus.latitude && primaryStatus.longitude)" :style="{ height: fullHeight ? '100%' : 'auto' }">
    <div class="lkloc-map" id="mapContainer" :style="{ height: fullHeight ? '100%' : '360px' }"></div>
    <span class="zoom-float" v-if="primaryStatus.latitude" @click="zoomToPoint">
      <b-icon icon="search-plus" size="is-small"></b-icon>
    </span>
    <span class="last-updated">
      <span class="label">Location Updated:</span><strong>{{lastUpdated}}</strong>
    </span>
    <div class="marker" :style="{ color: primaryStatus.online ? onlineColor : offlineColor }" id="mapMarker" v-show="pin">
      <b-tooltip :label="tooltip" :type="primaryStatus.online ? 'is-success' : 'is-danger'">
        <font-awesome-icon :icon="['far', 'map-marker-alt']" size="2x" />
      </b-tooltip>
    </div>
  </div>
  <div class="kpt-remote-detail-map-p" v-else-if="isPrivate">
    <h5>Privacy Mode Enabled</h5>
  </div>
  <div class="kpt-remote-detail-map-x" v-else>
    <h5>Map not available.</h5>
  </div>
</template>
<script>
import { formatDistanceToNow, isBefore } from 'date-fns';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = window.mapApiKey;

export default {
  data() {
    return {
      map: null,
      pin: null,
      state: 'Offline',
      onlineColor: '#65BD81',
      offlineColor: '#FF5959',
      formatDistanceToNow
    };
  },
  created() {
    mapboxgl.accessToken = this.$store.state.appConfig.mapboxKey;
  },
  mounted() {
    if (!this.primaryStatus.latitude && this.primaryStatus.longitude) return;
    if (this.map == null) {
      // store 'this', because mapbox is bad
      const self = this;
      setTimeout(() => {
        // instantiate the map
        self.map = new mapboxgl.Map({
          container: 'mapContainer',
          style: `mapbox://styles/mapbox/${self.mapStyle}`,
          center: [this.primaryStatus.longitude, this.primaryStatus.latitude], // offset a bit to show more civilization
          zoom: 8
        });
        self.loadMap();
      }, 50);
    }
  },
  props: {
    satellite: {
      type: Object,
      default: () => {}
    },
    cellular: {
      type: Object,
      default: () => {}
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
    mapStyle: {
      type: String,
      default: 'light-v9'
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltip() {
      return this.primaryStatus.online ? 'Online' : 'Offline';
    },
    lastUpdated() {
      const updatedTimestamp = this.primaryStatus.satelliteLocationUpdatedOn || this.primaryStatus.cellularLocationUpdatedOn;
      if (!updatedTimestamp || updatedTimestamp == '1970-01-01T00:00:00') return 'Never';
      return formatDistanceToNow(new Date(updatedTimestamp), { addSuffix: true });
    },
    primaryStatus() {
      if (this.satellite && this.satellite.satelliteLocationUpdatedOn) return this.satellite;
      return {};
    }
  },
  methods: {
    loadMap() {
      const self = this;
      if (self.map && self.map.loaded()) {
        // self.map.flyTo({ center: [this.primaryStatus.longitude, this.primaryStatus.latitude], zoom: 8 });
        const el = document.getElementById('mapMarker');
        self.pin = new mapboxgl.Marker(el)
          .setLngLat([this.primaryStatus.longitude, this.primaryStatus.latitude])
          .addTo(self.map);
        self.map.addControl(new mapboxgl.NavigationControl(), 'top-left');
      } else {
        setTimeout(() => { // retry loading map after one second
          this.loadMap();
        }, 200);
      }
    },
    zoomToPoint() {
      if (this.primaryStatus.longitude && this.primaryStatus.latitude) {
        this.map.flyTo({ center: [this.primaryStatus.longitude, this.primaryStatus.latitude], zoom: 16 });
      }
    }
  },
  watch: {
    // eslint-disable-next-line quote-props, func-names
    'primaryStatus': function (newValue, oldValue) {
      if (newValue && oldValue && (newValue.latitude != oldValue.latitude || newValue.longitude != oldValue.longitude)) {
        if (this.map && this.map.loaded()) {
          const lat = newValue.latitude;
          const lng = newValue.longitude;
          this.map.flyTo({ center: [lng, lat], zoom: 8 });
          this.pin.setLngLat([lng, lat]);
        }
      }
    }
  },
  destroyed() {
    if (this.map) {
      this.map.remove();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../node_modules/mapbox-gl/dist/mapbox-gl.css";
@import "../../styles/_colors";

.kpt-remote-detail-map-x, .kpt-remote-detail-map-p {
  height: 360px;
  background: $grey-lighter;
  display: flex;
  justify-content: center;
  align-items: center;
}

.kpt-remote-detail-map {
  position: relative;

  .zoom-float {
    position: absolute;
    top: 108px;
    padding: 7px 7px 0px;
    color: $grey-darker;
    border: 2px solid darken($grey-lighter, 5%);
    border-radius: 8px;
    left: 8px;
    background: white;
    z-index: 9;
    cursor: pointer;
    
    &:hover {
      background: $white-ter;
    }
  }

  .last-updated {
    position: absolute;
    right: 8px;
    top: 8px;

    .label {
      margin-bottom: -6px;
    }
  }

  #mapContainer {
    flex: 1 0 auto;
  }
}
</style>
<style lang="scss">
@import "../../styles/_colors";

.lkloc-map {
  .marker {
    i {
      font-size: 36px;
      color: $blue;
      position: absolute;
      left: -11px;
      top: -36px;
    }
  }
}
</style>
